<script>
import taiwanBankCode from '@utils/taiwan-bank-code'
const initData = () => {
  return {
    phoneCode: '+886',
    phone: '',
    hidden: 0,
    name: '',
    alias: '',
    type: '',
    description: '',
    notice: '',
    location: {
      name: '',
      country: '臺灣',
      city: '',
      address: '',
      district: '',
    },
    staffs: [],
    introimage: '',
    image: '',
    images: [],
    video: '',
    orderExtrafields: [],
    allowOverlap: 0,
    showPrice: 1,
    lineId: '',
    lineFriendUrl: '',
    fbFanpageUrl: '',
    lat: '',
    lng: '',
    storeType: ''
  }
}
export default {
  data() {
    return {
      socialChecked: false,
      submitData: {
        lineId: '',
        fbFanpageUrl: '',
        gaNo: '',
        analyticsVehicle: '',
        lineFriendUrl: ''
      },
      taiwanBankCode
    }
  },
  methods: {
    initEditValue() {
      const subKey = Object.keys(this.submitData)
      for (let i = 0, len = subKey.length; i < len; i++) {
        this.$set(this.submitData, subKey[i], this.defaultValue[`${subKey[i]}`])
      }
    },
    async getMerchant(type) {
      const { lineId, fbFanpageUrl, lineFriendUrl } = await this.$store.dispatch('merchant/fetchSingle')
      if (type === 'social') {
        this.submitData.lineId = lineId
        this.submitData.fbFanpageUrl = fbFanpageUrl
        this.submitData.lineFriendUrl = lineFriendUrl
      }
    },
  },
  props: {
    defaultValue: {
      type: Object,
      default: () => initData(),
    },
  },
  mounted() {
    this.initEditValue()
  },
  watch: {
    socialChecked(value) {
      if (value) {
        this.getMerchant('social')
      }
    },
  }
}
</script>
<template>
  <el-form ref="form" :model="submitData" label-position="top" class="el-form--floating"
    :class="$style.page">
    <!-- 上方社群資料 -->
    <div :class="$style.socialPart">
      <h4 class="form-block-title">社群資訊</h4>
      <el-button class="is-round mb-3" @click="getMerchant('social')">和商店設定相同
      </el-button>
    </div>
    <el-row :gutter="20" >
      <el-col :sm="12" :span="24">
        <el-form-item label="官方 Line@ 帳號">
          <el-input v-model="submitData.lineId" class="bg-white is-rounded is-border" />
        </el-form-item>
      </el-col>
      <el-col :sm="12" :span="24">
        <el-form-item label="加入Line好友網址">
          <el-input v-model="submitData.lineFriendUrl"
            class="is-border is-rounded bg-white">
          </el-input>
        </el-form-item>
      </el-col>
    </el-row>
    <el-row :gutter="20" class="h-96">
      <el-col :sm="24" :span="24">
        <el-form-item label="Facebook 粉絲專頁">
          <el-input v-model="submitData.fbFanpageUrl" class="bg-white is-rounded is-border" />
        </el-form-item>
      </el-col>
    </el-row>
    <!-- <el-row :gutter="20" class="h-96">
      <el-col :sm="24" :span="24">
        <el-form-item label="網站分析工具">
          <span slot="label" for="">網站分析工具
            <el-tooltip content="即為Meta Description，顯示於搜尋引擎結果，用以簡短描述您的網頁內容。建議長度為110~150字以內。" placement="right">
              <BaseIcon name="info-circle" />
            </el-tooltip>
          </span>
          <el-select v-model="submitData.analyticsVehicle" filterable placeholder="請選擇"
            class="is-border arrow-color-secondary">
            <el-option label="Google Analytics" value="ga">
            </el-option>
          </el-select>
        </el-form-item>
      </el-col>
    </el-row> -->
    <!-- <el-row :gutter="20" class="h-96">
      <el-col :sm="24" :span="24">
        <el-form-item label="Google Analytics 追蹤編號">
          <el-input v-model="submitData.gaNo" class="bg-white is-rounded is-border" />
        </el-form-item>
      </el-col>
    </el-row> -->
    <div class="only-bottom-line" style="margin-top:14px;margin-bottom: 24px;"></div>
    <!-- <h4 data-tour-text="" class="form-block-title">匯款資訊 <span class="text-muted">（如需使用金流服務，請與iPetBooking 聯繫
        (02)2531-6628）</span></h4>
    <el-row :gutter="20">
      <el-col :md="12">
        <el-form-item label="匯款銀行">
          <el-select v-model="submitData.atmBank" placeholder="請選擇匯款銀行" :popper-append-to-body="false"
            class="bg-white is-rounded is-border">
            <el-option v-for="item in taiwanBankCode" :key="item.code" :value="`${item.code}-${item.name}`">
              {{`${item.code}-${item.name}`}}
            </el-option>
          </el-select>
        </el-form-item>
      </el-col>
      <el-col :md="12">
        <el-form-item label="匯款帳號" prop="atmAccount">
          <el-input v-model="submitData.atmAccount" class="bg-white is-rounded is-border" />
        </el-form-item>
      </el-col>
      <el-col :md="24">
        <el-form-item label="戶名">
          <el-input v-model="submitData.atmAccountName" class="bg-white is-rounded is-border" />
        </el-form-item>
      </el-col>
    </el-row> -->
  </el-form>
</template>

<style lang="scss" module>
.page {
  background-color: white;
  padding: 3px 20px 18px;
}

.socialPart {
  display: flex;
  align-items: flex-start;
  flex-direction: column;
  justify-content: flex-start;
  >h4 {
    margin-right: 12px;
  }
}

.rowHeight {
  height: 96px;
  margin-bottom: 0px;
}
</style>